import { Button } from "flowbite-react";
import React from "react";

export default function GaleryFullContent() {
  return (
    <div className="container mt-20 mb-20">
      <div className="flex justify-center">
        <p className="text-lg mr-5 text-lime-700 font-bold">All</p>
        <p className="text-lg mr-5">Architecture</p>
        <p className="text-lg mr-5">Interior</p>
        <p className="text-lg mr-5">Landscape</p>
        <p className="text-lg mr-5">Planning</p>
      </div>

      <div className="grid grid-cols-2 mt-7">
        <div className="col-span-1">
          <img
            src={require("../../images/galery-1.jpg")}
            alt="Foto 1"
            className="w-full h-96 object-cover"
          />
        </div>

        <div className="col-span-1">
          <img
            src={require("../../images/galery-2.jpg")}
            alt="Foto 1"
            className="w-full h-96 object-cover"
          />
        </div>
      </div>

      <div className="grid grid-cols-2">
        <div className="col-span-1">
          <img
            src={require("../../images/galery-3.jpg")}
            alt="Foto 1"
            className="w-full h-96 object-cover"
          />
        </div>

        <div className="col-span-1">
          <img
            src={require("../../images/galery-4.jpg")}
            alt="Foto 1"
            className="w-full h-96 object-cover"
          />
        </div>
      </div>

      <div className="grid grid-cols-2">
        <div className="col-span-1">
          <img
            src={require("../../images/galery-5.jpg")}
            alt="Foto 1"
            className="w-full h-96 object-cover"
          />
        </div>

        <div className="col-span-1">
          <img
            src={require("../../images/galery-6.jpg")}
            alt="Foto 1"
            className="w-full h-96 object-cover"
          />
        </div>
      </div>

      <div className="grid grid-cols-2">
        <div className="col-span-1">
          <img
            src={require("../../images/galery-7.jpg")}
            alt="Foto 1"
            className="w-full h-96 object-cover"
          />
        </div>

        <div className="col-span-1">
          <img
            src={require("../../images/galery-8.jpg")}
            alt="Foto 1"
            className="w-full h-96 object-cover"
          />
        </div>
      </div>

      <div className="grid grid-cols-2">
        <div className="col-span-1">
          <img
            src={require("../../images/galery-9.jpg")}
            alt="Foto 1"
            className="w-full h-96 object-cover"
          />
        </div>

        <div className="col-span-1">
          <img
            src={require("../../images/galery-10.jpg")}
            alt="Foto 1"
            className="w-full h-96 object-cover"
          />
        </div>
      </div>

      <div className="grid grid-cols-2">
        <div className="col-span-1">
          <img
            src={require("../../images/galery-11.jpg")}
            alt="Foto 1"
            className="w-full h-96 object-cover"
          />
        </div>

        <div className="col-span-1">
          <img
            src={require("../../images/galery-12.jpg")}
            alt="Foto 1"
            className="w-full h-96 object-cover"
          />
        </div>
      </div>

      <div className="flex justify-center mt-8">
        <Button color="success">Load More</Button>
      </div>
    </div>
  );
}
